module.exports = __webpack_public_path__ + "img/69669e6.jpg";